import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Gamepad2, Wallet, Globe, Users, Settings, Send } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useConfirm } from '../context/ConfirmContext';
import { Sidebar } from '../components/Sidebar';
import type { SidebarNavItem } from '../components/Sidebar';
import { JackpotWidget } from '../components/jackpot/JackpotWidget';

interface UserLayoutProps {
  children?: React.ReactNode;
}

const NAV_ITEMS: SidebarNavItem[] = [
  { path: '/user/lobby', label: 'Sảnh', icon: Gamepad2 },
  { path: '/user/accounts', label: 'Kho tài khoản', icon: Wallet },
  { path: '/user/proxy', label: 'Proxy', icon: Globe },
  { path: '/user/group', label: 'Nhóm', icon: Users },
  { path: '/user/settings', label: 'Cài đặt', icon: Settings },
];

export const UserLayout: React.FC<UserLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const confirm = useConfirm();

  const handleLogout = async () => {
    const isConfirmed = await confirm({
      title: 'Đăng xuất',
      message: 'Bạn có chắc chắn muốn đăng xuất?',
    });
    if (isConfirmed) {
      logout();
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[#0d0f14]">
      <Sidebar
        navItems={NAV_ITEMS}
        logoText="Sunwin"
        logoAccent="No Hu"
        userName={user?.username ?? ''}
        userRole={user?.role ?? ''}
        onLogout={() => {
          void handleLogout();
        }}
      />
      <main className="custom-scrollbar flex-1 overflow-y-auto p-6">
        <div className="mx-auto max-w-7xl">{children}</div>
      </main>
      <JackpotWidget />
    </div>
  );
};

export default UserLayout;
